<template lang="pug">
v-combobox(
  :value="value"
  :label="label"
  no-filter
  item-text="unrestricted_value"
  :search-input.sync="search"
  :items="items"
  v-bind="$attrs"
  @input="this.$emit('input', $event);"
)
</template>

<script>

/**
 * Проверяет кол-во символов в @val больше или рано @minLen после trim()
 * @param val { String } - значение поля
 * @param minLen { Number } - кол-во символов строки
 * @returns {boolean}
 * @public
 */
function checkMinLength(val, minLen) {
  const str = val.trim();
  return str.length >= minLen;
}

/**
 * Компонент получения адреса по значению поля через сервис dadata.ru
 * при использовании в компонентах для не авторизованных пользователей это просто текстовое поле
 * @displayName Address Input
 */
export default {
  props: {
    value: { type: [Object, String], default: '' },
    reset: { type: Boolean, default: false },
    label: { type: String, default: 'Адрес (начните ввод)' },
    returnString: { type: Boolean, default: false },
  },
  data() {
    return {
      search: '',
      model: this.value || {},
      items: [],
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {
    reset(val) {
      if (val) {
        this.search = '';
        this.model = {};
        this.items = [];
      }
    },
    model(val) {
      this.fetchSuggestions(val.unrestricted_value, 1)
        .then((response) => {
          const adressData = this.serializeAddressName(
            response.data?.suggestions[0]?.unrestricted_value,
          );
          this.$emit('input', adressData);
        });
    },
    search(val) {
      if (val && typeof val === 'string') {
        if (checkMinLength(val, 3)) {
          this.fetchSuggestions(val.trim(), 20)
            .then((response) => {
              const sug = response.data.suggestions.map((item) => ({
                ...item,
                unrestricted_value: this.serializeAddressName(item.unrestricted_value),
              }));
              this.items = sug;
            });
        }
      } else {
        this.$nextTick(() => {
          this.search = '';
        });
      }
    },
  },
  methods: {
    serializeAddressName(name) {
      const char = +name[0];
      if (char) {
        return name.slice(8);
      }
      return name;
    },
    /**
     * Запрос на получение данных с сервиса dadata.ru
     * @param query
     * @param count
     * @returns {Promise<AxiosResponse<any>>}
     */
    fetchSuggestions(query, count) {
      return this.$api.system.getDadataAddress({
        query,
        count,
      });
    },
  },
};
</script>
